import { ContactCard } from "./ContactCard";
import { DraggableCard } from "./DraggableCard";
import { DroppableArea } from "./DroppableArea";
import { useState, useCallback } from "react";
import { ChevronDown } from "lucide-react";

const PAGE_SIZE = 30;

export function KanbanColumn({ etapa, contacts, onEdit, onWhatsApp, onNote, onMove, onSchedule, onDelete, cardParadoDias = 3, isMobile = false, activeId = null }) {
  const [visible, setVisible] = useState(PAGE_SIZE);
  const shown = contacts.slice(0, visible);
  const remaining = contacts.length - visible;

  const loadMore = useCallback(() => setVisible((v) => v + PAGE_SIZE), []);

  return (
    <div data-testid={`kanban-column-${etapa.id}`} className="flex-shrink-0 w-full md:w-80 md:min-w-[320px] flex flex-col h-full">
      <div className="flex items-center justify-between px-1 pb-3">
        <div className="flex items-center gap-2">
          <span className="text-xs font-semibold uppercase tracking-wider text-zinc-500">{etapa.label}</span>
          {etapa.id === "agendado" && <div className="w-1.5 h-1.5 rounded-full bg-green-500" />}
          {etapa.id === "perdido" && <div className="w-1.5 h-1.5 rounded-full bg-red-500" />}
        </div>
        <span className="text-xs text-zinc-600 tabular-nums">{contacts.length}</span>
      </div>

      <DroppableArea
        id={`col-${etapa.id}`}
        disabled={isMobile}
        className="flex-1 overflow-y-auto pr-1 pb-4 rounded-lg transition-colors duration-150"
        overClassName="bg-[var(--salonup-brand-alpha-08)] ring-1 ring-[var(--salonup-brand)]/40"
      >
        <div className="space-y-3 pt-1 min-h-[60px]">
          {shown.map((c) => (
            <DraggableCard key={c.id} contact={c} disabled={isMobile}>
              <ContactCard
                contact={c}
                etapa={etapa.id}
                onEdit={() => onEdit(c)}
                onWhatsApp={() => onWhatsApp(c)}
                onNote={() => onNote(c)}
                onMove={(targetEtapa) => onMove(c, targetEtapa)}
                onSchedule={() => onSchedule(c)}
                onDelete={() => onDelete(c.id)}
                cardParadoDias={cardParadoDias}
                isActive={c.id === activeId}
              />
            </DraggableCard>
          ))}
          {remaining > 0 && (
            <button onClick={loadMore} className="w-full flex items-center justify-center gap-1.5 py-2.5 text-xs text-zinc-500 hover:text-zinc-300 transition-colors">
              <ChevronDown className="h-3.5 w-3.5" />
              Carregar mais {Math.min(remaining, PAGE_SIZE)} de {remaining}
            </button>
          )}
          {contacts.length === 0 && (<div className="text-center py-12 text-zinc-700 text-xs">Vazio</div>)}
        </div>
      </DroppableArea>
    </div>
  );
}
